<div class="btn-group">
  <button
    class=" ms-1"
    id="addButtonGroup"
    mat-stroked-button
    (click)="addRecord()">
    Add
  </button>
</div>